import { createStyles } from "@mui/styles";
import Button from "@ellucian/react-design-system/core/es/Button";
import Card, { CardContent } from "@ellucian/react-design-system/core/es/Card";
import FormControl, { FormHelperText } from "@ellucian/react-design-system/core/es/FormControl";
import { Theme, withStyles } from "@ellucian/react-design-system/core/es/styles";
import TextField from "@ellucian/react-design-system/core/es/TextField";
import Typography from "@ellucian/react-design-system/core/es/Typography";
import {
  sizingLarge, spacing40,
  spacing70,
} from "@ellucian/react-design-system/core/styles/tokens";
import PropTypes from "prop-types";
import * as React from "react";
import { FormattedMessage } from "react-intl";
import withIntl, { IntlProps } from "../hoc/ReactIntlHOC";
import { getStyles } from "../transitApp/styles";

const styles = (_theme: Theme) =>
  createStyles({
    root: {
      flexGrow: 1,
    },
    card: {
      maxWidth: "28.5rem",
      margin: "auto",
      marginTop: "3.75rem",
    },
    formField: {
      marginTop: spacing40,
      width: "100% !important",
    },
    iPhone5FormField: {
      marginTop: spacing40,
      paddingRight: spacing70,
    },
    formHeader: {
      margin: "auto",
      fontSize: sizingLarge,
    },
    iPhone5Margin: {
      marginLeft: "-12rem !important",
    },
    signInButton: {
      marginTop: spacing40,
    },
    buttonFloat: {
      marginTop: spacing40,
      float: "right",
    },
    loginError: {
      marginTop: spacing40,
      marginBottom: "-2rem",
      fontSize: ".75rem",
    },
  });

interface IPageState {
  hasLoginError: boolean;
}

export class LoginForm extends React.Component<IntlProps, IPageState> {
  constructor(props: any) {
    super(props);
    this.state = {
      hasLoginError: false,
    };

    const urlSearchParams = new URLSearchParams(window.location.search);
    // If there is an 'error=true' in the query parameters
    if (
      urlSearchParams.has("error") &&
      urlSearchParams.get("error") === "true"
    ) {
      this.state = {
        hasLoginError: true,
      };
    }
  }
  // Remove the error message on user typing text
  onTextChanged = (_event: React.ChangeEvent<HTMLInputElement>) => {
    this.setState({ hasLoginError: false });
  };
  render() {
    const customId = "LoginForm";
    const { classes } = getStyles<typeof styles>(this.props);
    const { formatMessage } = this.props.intl;
    document.title = formatMessage({ id: "transit.login.page.title" });
    const HelperTextArea = this.state.hasLoginError ? (
      <FormHelperText
        className={classes.loginError}
        error={this.state.hasLoginError}
        filled={!this.state.hasLoginError}
      >
        <FormattedMessage id="transit.login.error" />
      </FormHelperText>
    ) : null;
    return (
      <div className={classes.root}>
        <Card id={`${customId}_Card`} className={classes.card}>
          <CardContent>
            <Typography
              variant="h1"
              className={
                screen.width > 340
                  ? classes.formHeader
                  : [classes.formHeader, classes.iPhone5Margin].join(" ")
              }
            >
              <FormattedMessage id="transit.login.header" />
            </Typography>
            <form name="sign-in-form" action="login" method="POST">
              <FormControl id={`${customId}_Container`} component="fieldset">
                <TextField
                  name="username"
                  id={`${customId}_username`}
                  label={formatMessage({ id: "transit.login.label.username" })}
                  className={screen.width <= 340 ? classes.iPhone5FormField : classes.formField}
                  onChange={this.onTextChanged}
                  fullWidth={screen.width <= 340}
                />
                <TextField
                  name="password"
                  id={`${customId}_password`}
                  label={formatMessage({ id: "transit.login.label.password" })}
                  type="password"
                  passwordToggle={true}
                  className={screen.width <= 340 ? classes.iPhone5FormField : classes.formField}
                  onChange={this.onTextChanged}
                  fullWidth={screen.width <= 340}
                />
                <Button type="submit" id={`${customId}_Button`} className={classes.buttonFloat}>
                  <FormattedMessage id="transit.login.button.signIn" />
                </Button>
                <br />
                {HelperTextArea}
              </FormControl>
            </form>
          </CardContent>
        </Card>
      </div>
    );
  }

  static contextTypes = {
    hasLoginError: PropTypes.string,
  };
}

export default withStyles<typeof LoginForm>(styles)(withIntl(LoginForm));
